import React from 'react';
// components
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
// styles
import contentStyles from 'styles';
import clsx from 'clsx';

export const TextControl = (props: TextFieldProps): JSX.Element => {
  const classes = contentStyles();

  return (
    <TextField
      {...props}
      className={ clsx(classes.formControl, props.className) }
    />
  );
};
